import axios from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./getHeaderOptions";
import { Logger } from '../utils/logger';

const API_ENDPOINT = API_URL + "api/v1";


export const getFormList = () => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.get(`${API_ENDPOINT}/custom-form`, {
    headers: obj,
  });
};
export const getFormListById = (id: string) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.get(`${API_ENDPOINT}/custom-form/${id}`, {
    headers: obj,
  });
};
export const createCustomForm = (data: object) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.post(`${API_ENDPOINT}/custom-form`, data, { headers: obj });
};
export const editCustomForm = (data: object, id: string) => {
  Logger.log('edit data =====>',data)
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.put(`${API_ENDPOINT}/custom-form/${id}`, {form:data}, { headers: obj });
};
export const deleteUserForm = (id: string) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem('auth_token') || ''
  }
  return axios.delete(`${API_ENDPOINT}/custom-form/${id}`, { headers: obj });


}
export const getWebFormView = (id:string) =>{
  let obj = {
      ...getHeaderOptions,
      Authorization: localStorage.getItem('auth_token') || ''
  }
  return axios.get(`${API_ENDPOINT}/custom-form/${id}/view`,{ headers: obj });
}
export const addWebFormResponse = (id:string ,data: object, ) =>{
  let obj = {
      ...getHeaderOptions,
      Authorization: localStorage.getItem('auth_token') || ''
  }
  return axios.post(`${API_ENDPOINT}/custom-form/${id}/response`,data , { headers: obj });
}

export const getCustomFormResponse = (responseId: string) =>{
  let obj = {
      ...getHeaderOptions,
      Authorization: localStorage.getItem('auth_token') || ''
  }
  return axios.get(`${API_ENDPOINT}/custom-form/response?customFormId=${responseId}`, { headers: obj });
}

export const getLeadFormResponse = (responseId: string) =>{
  let obj = {
      ...getHeaderOptions,
      Authorization: localStorage.getItem('auth_token') || ''
  }
  return axios.get(`${API_ENDPOINT}/custom-form/response?leadId=${responseId}`, { headers: obj });
}

export const publishForm = (data:any ,formId : string) =>{
  let obj = {
      ...getHeaderOptions,
      Authorization: localStorage.getItem('auth_token') || ''
  }
  return axios.put(`${API_ENDPOINT}/custom-form/${formId}`,data,{ headers: obj });
}
export const uploadFile = async (file:any ,formId : string,fileName:string) =>{
  let obj = {
      ...getHeaderOptions,
      Authorization: localStorage.getItem('auth_token') || ''
  }
  const fileAry = file.name.split('.')
  const fileExtension = fileAry.pop()
  const fileNames = fileAry.join('')
  
  const respoo = await axios.get(`${API_ENDPOINT}/custom-form/${formId}/sign-url?fileType=${fileExtension}&requestType=put&fileName=${fileNames}`,{ headers: obj });
  const url = respoo.data.data.data.signedUrl
  if(url){
    try {
      const fileUpload = await axios.put(url,file)
      Logger.log('fileUpload',fileUpload)
      if(fileUpload.status ==200){
        return respoo.data.data
      }
     
    } catch (error) {
      console.error('Error occurred during file upload:', error);
    }
  }
}

export const getPaymentLink = (data:any) =>{
  let obj = {
      ...getHeaderOptions,
      Authorization: localStorage.getItem('auth_token') || ''
  }
  return axios.post(`${API_ENDPOINT}/payment-link/generate`,data,{ headers: obj });
}
export const checkPaymentStatus = (link:any) =>{
  let obj = {
      ...getHeaderOptions,
      Authorization: localStorage.getItem('auth_token') || ''
  }
  return axios.get(`${API_ENDPOINT}/payment-link/status?paymentLink=${link}`,{ headers: obj });
}
export const formLeadList = (id: any) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem('auth_token') || ''
  }
  return axios.get(`${API_ENDPOINT}/lead-list${id}`, { headers: obj });
}

export const formDeleteLeadList = (id: string) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem('auth_token') || ''
  }
  return axios.post(`${API_ENDPOINT}/lead-list/${id}`, { headers: obj });
}

export const postDraftFormData = (
  uniqueCode: string,
  formData: any,
  isSubmitted: boolean = false,
  draftResponseId?: string
) => {
  // Public endpoint - no auth required (like addWebFormResponse)
  let obj = {
      ...getHeaderOptions
  }

  // Build request body - wrap formData to maintain backward compatibility
  const requestBody: any = {
    formData, // Keep existing structure
    isSubmitted
  };

  // If we have a draft response ID, include it for updating existing draft
  if (draftResponseId) {
    requestBody._id = draftResponseId;
  }

  return axios.post(`${API_ENDPOINT}/custom-form/${uniqueCode}/draft-response`, requestBody, {
    headers: obj,
    validateStatus: (status) => status < 500 // Don't throw on 404
  }).catch(err => {
    // Catch HTML responses (404 pages) and convert to proper error
    if (err.message?.includes('Unexpected token')) {
      throw new Error('Draft API endpoint not found (404)');
    }
    throw err;
  });
}